<template>
    <div class="submit-your-own">
        <v-dialog v-model="successDialog" width="500">
            <v-card>
                <v-card-title class="text-h5 lighten-2">
                    Puzzle Successfully Submitted
                </v-card-title>

                <v-card-text
                    >Thanks for submitting a puzzle to Puzzle of the Day! If
                    your puzzle is chosen, you may see it show up in the game.
                    We will also email any creators who have their puzzles
                    picked for the game!</v-card-text
                >

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="successDialog = false">
                        Done
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="failDialog" width="500">
            <v-card>
                <v-card-title class="text-h5 lighten-2">
                    Error Submitting Puzzle
                </v-card-title>

                <v-card-text
                    >Unfortunately we encountered an error submitting your
                    puzzle. Please try again later.</v-card-text
                >

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="failDialog = false">
                        Done
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-container>
            <v-col>
                <div class="user-stats">
                    <div class="username display-2">
                        <div>Submit your Own Puzzle</div>
                    </div>

                    <div class="descriptor">
                        Every Thursday we feature a puzzle from one of our
                        users! If chosen, your puzzle will be played as the
                        daily puzzle by all players on a given day. Your name
                        and Puzzle Rank will also optionally be read out to the
                        other players. Check the tips below on how to design a
                        quality puzzle.
                    </div>

                    <div class="display-1 section-head">
                        Puzzle Details
                        <v-dialog v-model="dialog" width="500">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="section-head"
                                    color="#42bdbb"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    :style="{
                                        marginLeft: '10px',
                                        marginTop: '5px',
                                    }"
                                >
                                    <v-icon dark> info </v-icon> Puzzle Tips
                                </v-btn>
                            </template>

                            <v-card>
                                <v-card-title class="text-h5 lighten-2">
                                    Puzzle Tips
                                </v-card-title>

                                <v-card-text style="text-align: left">
                                    <ul>
                                        <li>
                                            <b>Connect words to the theme</b>
                                            <ul style="font-style: italic">
                                                The words you use should connect
                                                to the theme, but the clues
                                                don't need to. In fact,
                                                sometimes it's too easy if all
                                                the clues are related to the
                                                theme itself.
                                            </ul>
                                        </li>
                                        <li>
                                            <b>Keep it fun</b>
                                            <ul style="font-style: italic">
                                                Keep the puzzles light-hearted
                                                and fun. Don't use any clues
                                                that are crazy difficult, but
                                                make sure to keep somewhat of a
                                                challenge. Anything far too
                                                obscure should probably be
                                                omitted.
                                            </ul>
                                        </li>
                                        <li>
                                            <b
                                                >Don't use numbers in
                                                solutions</b
                                            >
                                            <ul style="font-style: italic">
                                                Any numbers will not work as
                                                solutions (but you can use them
                                                as clues). You also need to
                                                avoid any other commands used in
                                                the game such as "yes", "no",
                                                "skip", "reveal", "guess",
                                                "quit", "restart", "alexa", etc.
                                            </ul>
                                        </li>
                                    </ul>
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="primary"
                                        text
                                        @click="dialog = false"
                                    >
                                        Done
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>

                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container>
                            <v-text-field
                                label="Theme"
                                solo
                                v-model="theme"
                                :rules="themeRules"
                            ></v-text-field>

                            <v-row class="word-row">
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Word One"
                                        solo
                                        v-model="wordOne"
                                        :rules="wordRules"
                                    ></v-text-field
                                ></v-col>
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Clue One"
                                        solo
                                        v-model="clueOne"
                                        :rules="clueRules"
                                    ></v-text-field
                                ></v-col>
                            </v-row>
                            <v-row class="word-row">
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Word Two"
                                        solo
                                        v-model="wordTwo"
                                        :rules="wordRules"
                                    ></v-text-field
                                ></v-col>
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Clue Two"
                                        solo
                                        v-model="clueTwo"
                                        :rules="clueRules"
                                    ></v-text-field
                                ></v-col>
                            </v-row>
                            <v-row class="word-row">
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Word Three"
                                        solo
                                        v-model="wordThree"
                                        :rules="wordRules"
                                    ></v-text-field
                                ></v-col>
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Clue Three"
                                        solo
                                        v-model="clueThree"
                                        :rules="clueRules"
                                    ></v-text-field
                                ></v-col>
                            </v-row>
                            <v-row class="word-row">
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Word Four"
                                        solo
                                        v-model="wordFour"
                                        :rules="wordRules"
                                    ></v-text-field
                                ></v-col>
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Clue Four"
                                        solo
                                        v-model="clueFour"
                                        :rules="clueRules"
                                    ></v-text-field
                                ></v-col>
                            </v-row>
                            <v-row class="word-row">
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Word Five"
                                        solo
                                        v-model="wordFive"
                                        :rules="wordRules"
                                    ></v-text-field
                                ></v-col>
                                <v-col class="col-12 col-md-6"
                                    ><v-text-field
                                        label="Clue Five"
                                        solo
                                        v-model="clueFive"
                                        :rules="clueRules"
                                    ></v-text-field
                                ></v-col>
                            </v-row>

                            <v-select
                                solo
                                v-model="difficulty"
                                label="Difficulty"
                                :rules="difficultyRules"
                                :items="[
                                    { text: 'Easy', value: 'EASY' },
                                    { text: 'Medium', value: 'MEDIUM' },
                                    { text: 'Hard', value: 'HARD' },
                                ]"
                            >
                            </v-select>
                        </v-container>

                        <div class="display-1 section-head">User Info</div>
                        <v-container>
                            <v-checkbox
                                v-model="showName"
                                label="Show my name/rank to other players if puzzle is chosen"
                            >
                            </v-checkbox>
                            <v-text-field
                                v-model="email"
                                label="Email"
                                solo
                                :rules="emailRules"
                            ></v-text-field>
                        </v-container>

                        <v-btn color="secondary" @click="submitPuzzle"
                            >Submit Puzzle</v-btn
                        >
                    </v-form>
                </div>
            </v-col>
        </v-container>
    </div>
</template>

<script>
/* eslint-disable */
import Avatar from "@/components/Avatar.vue";
import axios from "axios";
import moment from "moment";
import RecentGames from "@/components/Profile/RecentGames.vue";
import UserStats from "@/components/Profile/UserStats.vue";

export default {
    name: "Profile",
    props: ["userHash", "authenticated"],
    components: { Avatar, RecentGames, UserStats },
    data() {
        return {
            dialog: false,
            successDialog: false,
            failDialog: false,
            userId: "",
            email: "",
            difficulty: "",
            theme: "",
            showName: "",
            wordOne: "",
            wordTwo: "",
            wordThree: "",
            wordFour: "",
            wordFive: "",
            clueOne: "",
            clueTwo: "",
            clueThree: "",
            clueFour: "",
            clueFive: "",

            emailRules: [
                (v) => !!v || "Email is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],

            wordRules: [
                (v) => !!v || "Word is required",
                (v) =>
                    (v && v.length <= 30) ||
                    "Word must be less than 30 characters",
                (v) =>
                    (v && v.length >= 3) ||
                    "Word must be at least 3 characters",
            ],

            themeRules: [
                (v) => !!v || "Theme is required",
                (v) =>
                    (v && v.length <= 30) ||
                    "Theme must be less than 30 characters",
                (v) =>
                    (v && v.length >= 5) ||
                    "Theme must be at least 5 characters",
            ],

            clueRules: [
                (v) => !!v || "Clue is required",
                (v) =>
                    (v && v.length <= 80) ||
                    "Clue must be less than 80 characters",
                (v) =>
                    (v && v.length >= 3) ||
                    "Clue must be at least 3 characters",
            ],

            difficultyRules: [(v) => !!v || "Difficulty is required"],
        };
    },
    methods: {
        submitPuzzle() {
            var validated = this.$refs.form.validate();
            if (validated) {
                axios
                    .post(
                        `https://i0tr7oa202.execute-api.us-east-1.amazonaws.com/dev/submitpuzzle`,
                        {
                            userId: this.userId,
                            email: this.email,
                            difficulty: this.difficulty,
                            theme: this.theme,
                            showName: this.showName,
                            wordOne: this.wordOne,
                            wordTwo: this.wordTwo,
                            wordThree: this.wordThree,
                            wordFour: this.wordFour,
                            wordFive: this.wordFive,
                            clueOne: this.clueOne,
                            clueTwo: this.clueTwo,
                            clueThree: this.clueThree,
                            clueFour: this.clueFour,
                            clueFive: this.clueFive,
                        }
                    )
                    .then((response) => {
                        this.successDialog = true;
                        this.$refs.form.reset();
                    })
                    .catch((error) => {
                        this.failDialog = true;
                        console.log(error);
                    });
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.profile-header {
    text-align: center;
    margin-bottom: 20px;
}

.descriptor {
    margin-top: 10px;
    margin-bottom: 10px;
}

.section-head {
    margin-bottom: 10px;
}
.user-stats {
    text-align: center;
    left: 0;
    right: 0;
    padding: 20px 20px 30px 20px;
    width: 90%;
    margin: auto;
    border: 2px solid $pod-teal;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
}

.word-row {
}

@media only screen and (max-width: 600px) {
    .word-row {
        :first-child {
            padding-bottom: 0;
        }
        :last-child {
            padding-top: 0;
        }
    }
}

.section-container {
    display: flex;
    justify-content: space-around;
}
</style>

<style lang="scss">
.submit-your-own {
    .v-input__slot {
    }
}
</style>
